import React from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

import {gapFixerClass} from '@/libs/styleHelper';

import './MembraneCutOffSelection.less';

function SelectionDropdowns({disabled, value, onChange, name, unit, options, id, version}) {
  return (
    <div
      className={`membrane-cutoff-size-selection ${gapFixerClass()} div-3col center`}
      disabled={disabled}
      id={`selection-dropdowns-${id}`}
    >
      <p>{name}</p>
      <Select
        id={id}
        name="form-field-name"
        options={options}
        className="membraneCutOffSizeSelect"
        value={value}
        onChange={onChange}
        clearable={false}
        searchable={false}
        placeholder=""
        // set selector to up
        menuContainerStyle={{
          top: 'auto',
          bottom: '100%',
          width: '100px',
          left: '-5px',
          maxHeight: '300px',
        }}
        disabled={disabled || version === 'V2'}
      />
      <p>{unit}</p>
    </div>
  );
}

SelectionDropdowns.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  unit: PropTypes.string,
  options: PropTypes.array,
  id: PropTypes.string,
  version: PropTypes.string,
};

SelectionDropdowns.defaultProps = {
  value: null,
  disabled: false,
  onChange: () => {},
  name: '',
  unit: '',
  options: [],
  id: '',
  version: '',
};

export default SelectionDropdowns;
